<template>
	<div class="page d-flex">
		<MenuComponent />
		<HistoryViewComponent	 />
	</div>
</template>

<script>

import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import HistoryViewComponent from '@/components/user/viewComponent/history/HistoryViewComponent.vue';

export default{
	name: 'HistoryView',
  components:{
    MenuComponent,
    HistoryViewComponent,
  }
}
</script>

